import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetMonthlyRegisteredClientsRequest } from './get-monthly-registered-clients.request';
import { GetMonthlyRegisteredClientsResponse } from './get-monthly-registered-clients.response';

@Injectable({ providedIn: 'root' })
export class GetMonthlyRegisteredClientsUseCase extends UseCase<GetMonthlyRegisteredClientsRequest, Observable<GetMonthlyRegisteredClientsResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _authBaseUrl = inject<string>('AUTH_BACKEND_URL' as never);
    private _getClientSnapshotsUrl = '/getClientSnapshots';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(
        request: GetMonthlyRegisteredClientsRequest | void
    ): Observable<GetMonthlyRegisteredClientsResponse> | void {
        return this._apiRequestService.sendRequest<GetMonthlyRegisteredClientsRequest, GetMonthlyRegisteredClientsResponse>(
            this._authBaseUrl,
            request as GetMonthlyRegisteredClientsRequest,
            true,
            this._getClientSnapshotsUrl
        );
    }
}
